<template>
    <v-data-table v-bind="{ items, headers, loading }" disable-sort disable-pagination hide-default-footer: :items-per-page="-1" ref="data-table">
        <template #body="props">
            <draggable v-if="$refs['data-table']" tag="tbody" :list="props.items" :sort="!loading || items.length < 2" @change="setNewIndex">
                <v-nodes :vnodes="$refs['data-table'].genItems(props.items, props)" />
            </draggable>
        </template>
        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value)" /> </template>
        <template #[`item.handle`]>
            <v-btn text tile color="grey darken-1" height="48" style="cursor: move" :disabled="items.length < 2">
                <v-icon>mdi-drag</v-icon>
            </v-btn>
        </template>
        <template #[`item.name`]="{ item }">
            <v-text-field v-model="item.name" v-bind="{ ...attrs_input__verticalTable }" @input="emit" />
        </template>
        <template #[`item.value`]="{ item }">
            <v-text-field v-model="item.value" v-bind="{ ...attrs_input__verticalTable }" @input="emit" />
        </template>
        <template #[`item.actions`]="{ item }">
            <v-btn text tile height="48" color="red" @click="pull(item)"> <v-icon>mdi-minus</v-icon> </v-btn>
        </template>
        <template #footer>
            <v-divider />
            <v-row no-gutters align="center">
                <v-col></v-col>
                <v-divider vertical />
                <v-col cols="auto">
                    <v-btn text tile height="58" color="primary" @click="push"> <v-icon>mdi-plus</v-icon> </v-btn>
                </v-col>
            </v-row>
        </template>
    </v-data-table>
</template>

<script>
// import { attrs_input__verticalTable, initDetails } from "@/assets/variables";
import Draggable from "vuedraggable";

const headers = [
    { width: 10, text: "", value: "handle", align: "center" },
    { width: 150, text: "이름", value: "name" },
    { width: 200, text: "내용", value: "value" },
    { width: 5, text: "", value: "actions" },
].map((item, index, array) => ({ ...item, formatter: item.formatter ?? ((value) => value ?? "-"), divider: index != array.length - 1, cellClass: (item.cellClass || "") + " px-0" }));

const initInfos = (info = {}) => ({
    ...info,
    name: info?.name || "",
    value: info?.value || ""
})

export default {
    components: {
        VNodes: { functional: true, render: (h, ctx) => ctx.props.vnodes },
        Draggable,
    },
    props: {
        value: { type: Array, default: () => [] },
    },
    data: () => ({
        headers,
        attrs_input__verticalTable: {
            flat: true,
            solo: true,
            class: "rounded-0",
            hideDetails: true,
            "persistent-placeholder": true,
        },
        loading: false,

        form: [],
    }),
    computed: {
        items() {
            return [...this.form];
        },
    },
    mounted() {
        this.sync();
    },
    methods: {
        sync() {
            this.form = [...this.value].map(initInfos);
        },
        pull(item) {
            const index = this.form.findIndex((val) => val.name === item.name);
            console.log(index)
            this.form.splice(index, 1);
            this.emit();
        },
        push() {
            this.form.push(initInfos());
            this.emit();
        },
        emit() {
            this.$emit("input", this.form);
        },
        async setNewIndex({ moved = {} }) {
            if (this.loading) return;
            this.loading = true;

            try {
                let { oldIndex, newIndex } = moved;
                this.form.splice(newIndex, 0, ...this.form.splice(oldIndex, 1));
            } finally {
                this.loading = false;
            }

            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
};
</script>

<style>
</style>